/* assets/flloom-addons.js
 * FluffyLoom custom fields:
 * - Live price from CURRENT variant (no cached base)
 * - Parse +/- amounts at label/option end (text, textarea, number, upload, radio, select)
 * - Currency conversion via Shopify/Intl
 * - Add-to-cart: positive net addons as hidden Fee product; negatives = display only
 * - Snapshot/restore field values across Dawn re-renders / variant changes
 */

(function () {
  // prevent double load
  if (window.__FLLOOM__ && window.__FLLOOM__.loaded) return;
  window.__FLLOOM__ = window.__FLLOOM__ || {};
  window.__FLLOOM__.loaded = true;
  window.__FLLOOM__.fieldCache = window.__FLLOOM__.fieldCache || [];

  var ROOT_ID = 'flloom-product';

  function getRoot() { return document.getElementById(ROOT_ID); }

  // ---- Currency helpers ----
  function getShopCurrency() {
    var root = getRoot();
    return (root && root.dataset.shopCurrency) || 'USD';
  }
  function getActiveCurrency() {
    var root = getRoot();
    var cur =
      (root && root.dataset.activeCurrency) ||
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      (window.Currency && Currency.currentCurrency) ||
      getShopCurrency();
    return cur;
  }
  function getMoneyFormat() {
    var root = getRoot();
    return (root && root.dataset.moneyFormat) || "${{amount}}";
  }
  function convertFromShopCents(cents) {
    var shop = getShopCurrency();
    var active = getActiveCurrency();
    if (active === shop) return cents;
    try {
      var rates =
        (window.Shopify && Shopify.currency && Shopify.currency.rates) ||
        (window.Currency && Currency.rates);
      if (!rates) return cents;
      var s = rates[shop], a = rates[active];
      if (!s || !a) return cents;
      return Math.round(cents * (a / s));
    } catch (e) { return cents; }
  }
  function formatMoney(cents) {
    var fmt = getMoneyFormat();
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, fmt);
    }
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: getActiveCurrency()
      }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }

  // ---- Price node detection ----
  function isVisible(el) {
    if (!el) return false;
    if (el.offsetParent === null && el.getClientRects().length === 0) return false;
    return true;
  }
  function getPriceNode() {
    var sale = document.querySelector('.price-item--sale');
    if (isVisible(sale)) return sale;
    var reg = document.querySelector('.price-item--regular');
    if (isVisible(reg)) return reg;
    var data = document.querySelector('[data-product-price]');
    if (isVisible(data)) return data;
    var any = document.querySelector('.product-price, .price');
    return any || null;
  }

  // ---- CURRENT variant price (live every render) ----
  function detectBaseCents() {
    var s = document.querySelector('script[data-selected-variant]');
    if (s) {
      try {
        var v = JSON.parse(s.textContent || '{}');
        if (typeof v.price === 'number') return v.price;
      } catch (e) {}
    }
    var root = getRoot();
    if (root) {
      var ds = parseInt(root.dataset.basePrice || '', 10);
      if (!isNaN(ds)) return ds;
    }
    var node = getPriceNode();
    if (node) {
      var m = (node.textContent || '').match(/(\d+(?:[.,]\d{1,2})?)/);
      if (m) return Math.round(parseFloat(m[1].replace(',', '.')) * 100);
    }
    return 0;
  }

  // ---- (+/- X) at END OF TEXT ----
  var DELTA_REGEX = /(?:\()\s*([+-])\s*(?:\p{Sc}|[A-Z]{3})?\s*(\d+(?:[.,]\d{1,2})?)\s*\)?\s*$|([+-])\s*(?:\p{Sc}|[A-Z]{3})?\s*(\d+(?:[.,]\d{1,2})?)\s*$/u;
  function extractDeltaCentsFromText(txt) {
    if (!txt) return 0;
    var t = String(txt).trim();
    var m = t.match(DELTA_REGEX);
    if (!m) return 0;
    var sign = m[1] || m[3] || '+';
    var numStr = m[2] || m[4] || '0';
    var signMul = sign === '-' ? -1 : 1;
    var num = parseFloat(numStr.replace(',', '.'));
    if (isNaN(num)) return 0;
    return signMul * Math.round(num * 100);
  }

  // ---- Parse addons across ALL fields ----
  function fieldWrapperType(wrapper) {
    var t = wrapper && wrapper.getAttribute('data-field-type');
    if (t) return t;
    if (wrapper.querySelector('.flloom-radio-group input[type="radio"]')) return 'radio';
    if (wrapper.querySelector('select')) return 'select';
    if (wrapper.querySelector('input[type="file"]')) return 'upload';
    if (wrapper.querySelector('input[type="number"]')) return 'number';
    if (wrapper.querySelector('textarea')) return 'textarea';
    return 'text';
  }
  function fieldWrapperLabel(wrapper) {
    var lbl = (wrapper.getAttribute('data-field-label') || '').trim();
    if (lbl) return lbl;
    var lab = wrapper.querySelector('label');
    return lab ? (lab.textContent || '').trim() : '';
  }

  function parseAddonCents() {
    var total = 0;

    var radios = document.querySelectorAll('.flloom-radio-group input[type="radio"]:checked');
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      var lab = r.closest && r.closest('label');
      var text = lab ? lab.textContent : r.value;
      total += extractDeltaCentsFromText(text);
    }

    var selects = document.querySelectorAll('select[data-field-type="select"], .flloom-field select');
    for (var j = 0; j < selects.length; j++) {
      var sel = selects[j];
      var opt = sel.options[sel.selectedIndex];
      if (!opt) continue;
      var ot = opt.textContent || opt.value;
      total += extractDeltaCentsFromText(ot);
    }

    var wrappers = document.querySelectorAll('.flloom-field');
    for (var k = 0; k < wrappers.length; k++) {
      var w = wrappers[k];
      var t = fieldWrapperType(w);
      var lbl = fieldWrapperLabel(w);
      if (!lbl) continue;

      if (t === 'text' || t === 'textarea' || t === 'number') {
        var inp = w.querySelector('input, textarea');
        var has = inp && String(inp.value || '').trim().length > 0;
        if (has) total += extractDeltaCentsFromText(lbl);
      } else if (t === 'upload') {
        var fi = w.querySelector('input[type="file"]');
        var picked = fi && fi.files && fi.files.length > 0;
        if (picked) total += extractDeltaCentsFromText(lbl);
      }
    }
    return total;
  }

  // ---- Price rendering: ALWAYS from current variant ----
  function renderPrice() {
    var base = detectBaseCents();
    var addons = parseAddonCents();
    var totalShopCents = base + addons;
    var node = getPriceNode();
    if (node) {
      var activeCents = convertFromShopCents(totalShopCents);
      node.textContent = formatMoney(activeCents);
    }
  }

  // ---- Snapshot / Restore custom fields ----
  function snapshotFields() {
    var data = [];
    var wrappers = document.querySelectorAll('.flloom-field');
    for (var i = 0; i < wrappers.length; i++) {
      var w = wrappers[i];
      var type = fieldWrapperType(w);
      var label = fieldWrapperLabel(w);
      if (!type || !label) continue;

      if (type === 'radio') {
        var checked = w.querySelector('input[type="radio"]:checked');
        if (checked) data.push({ type: type, label: label, val: checked.value });
      } else if (type === 'select') {
        var sel = w.querySelector('select');
        if (sel) data.push({ type: type, label: label, val: sel.value });
      } else if (type !== 'upload') {
        var inp = w.querySelector('input,textarea');
        if (inp) data.push({ type: type, label: label, val: inp.value });
      }
    }
    window.__FLLOOM__.fieldCache = data;
  }

  function restoreFields() {
    var cache = window.__FLLOOM__.fieldCache || [];
    if (!cache.length) return;
    for (var i = 0; i < cache.length; i++) {
      var it = cache[i];
      var candidates = document.querySelectorAll('.flloom-field[data-field-type="' + it.type + '"]');
      var w = null;
      if (candidates.length) {
        for (var c = 0; c < candidates.length; c++) {
          var lbl = fieldWrapperLabel(candidates[c]);
          if (lbl === it.label) { w = candidates[c]; break; }
        }
      }
      if (!w) {
        var all = document.querySelectorAll('.flloom-field');
        for (var a = 0; a < all.length; a++) {
          var lbl2 = fieldWrapperLabel(all[a]);
          if (lbl2 === it.label) { w = all[a]; break; }
        }
      }
      if (!w) continue;

      if (it.type === 'radio') {
        var options = w.querySelectorAll('input[type="radio"]');
        for (var r = 0; r < options.length; r++) {
          if (options[r].value === it.val) { options[r].checked = true; break; }
        }
      } else if (it.type === 'select') {
        var sel = w.querySelector('select');
        if (sel) sel.value = it.val;
      } else if (it.type !== 'upload') {
        var inp = w.querySelector('input,textarea');
        if (inp) inp.value = it.val;
      }
    }
    renderPrice();
  }

  // ---- Add-to-cart with Fee product ----
  window.addToCartWithFee = async function (productForm, opts) {
    opts = opts || {};
    var options = {
      feeMapping: opts.feeMapping || 'exact',
      feeProduct: opts.feeProduct || { handle: 'customization-fee' },
      redirectTo: typeof opts.redirectTo === 'string' ? opts.redirectTo : '/cart'
    };

    var fd = new FormData(productForm);
    var res1 = await fetch('/cart/add.js', { method: 'POST', body: fd });
    if (!res1.ok) { console.error('Main add failed'); return; }

    var addonsCents = parseAddonCents();
    if (addonsCents > 0) {
      var feeVariantId = await pickFeeVariant(addonsCents, options);
      if (feeVariantId) {
        var payload = new FormData();
        payload.append('id', String(feeVariantId));
        payload.append('quantity', '1');
        payload.append('properties[_type]', 'customization_fee');
        payload.append('properties[Amount (shop currency)]', (addonsCents / 100).toFixed(2));
        await fetch('/cart/add.js', { method: 'POST', body: payload });
      } else {
        console.warn('No matching fee variant found for', addonsCents, 'cents');
      }
    }

    if (options.redirectTo) window.location.href = options.redirectTo;
  };

  async function pickFeeVariant(addonsCents, options) {
    if (!options.feeProduct || (!options.feeProduct.handle && !options.feeProduct.id)) return null;

    if (!window.__FEE_PRODUCT__) {
      var url = options.feeProduct.id
        ? '/products/' + options.feeProduct.id + '.js'
        : '/products/' + options.feeProduct.handle + '.js';
      try {
        var r = await fetch(url);
        if (r.ok) window.__FEE_PRODUCT__ = await r.json();
      } catch (e) {}
    }
    var p = window.__FEE_PRODUCT__; if (!p) return null;

    var amount = Math.round(addonsCents / 100);
    if (options.feeMapping === 'exact') {
      var title = '+' + amount;
      var variants = p.variants || [];
      for (var i = 0; i < variants.length; i++) {
        var vt = (variants[i].title || '').trim();
        if (vt === title) return variants[i].id;
      }
    }
    return null;
  }

  // ---- Binding ----
  function bindProductForms() {
    var forms = document.querySelectorAll('product-form form[data-type="add-to-cart-form"]');
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      if (form.dataset.flloomBound === '1') continue;
      form.dataset.flloomBound = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var feeHandle = this.getAttribute('data-fee-handle') || 'customization-fee';
        window.addToCartWithFee(this, {
          feeMapping: 'exact',
          feeProduct: { handle: feeHandle },
          redirectTo: '/cart'
        });
      }, { passive: false });
    }
  }

  function bindFieldDelegates() {
    document.addEventListener('input', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.flloom-field')) renderPrice();
    });
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.closest && t.closest('.flloom-field')) renderPrice();

      if (t.closest && (t.closest('variant-radios') || t.closest('variant-selects'))) {
        snapshotFields();
        setTimeout(function () {
          bindProductForms();
          restoreFields();
          renderPrice();
        }, 0);
      }
    });

    document.addEventListener('variant:change', function () {
      snapshotFields();
      setTimeout(function () {
        bindProductForms();
        restoreFields();
        renderPrice();
      }, 0);
    });

    window.addEventListener('currency:change', renderPrice);
    window.addEventListener('shopify:currency-change', renderPrice);
  }

  var obs = new MutationObserver(function (muts) {
    var changed = false;
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType === 1 && (n.id === ROOT_ID || (n.querySelector && n.querySelector('#' + ROOT_ID)))) {
          changed = true; break;
        }
      }
      if (changed) break;
    }
    if (changed) {
      bindProductForms();
      restoreFields();
      renderPrice();
    }
  });
  try { obs.observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}

  function init() {
    if (!getRoot()) return;
    bindProductForms();
    bindFieldDelegates();
    renderPrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // --- Export for variant-selects patch ---
  window.Flloom = window.Flloom || {};
  window.Flloom.snapshotFields = snapshotFields;
  window.Flloom.restoreFields  = restoreFields;
  window.Flloom.renderPrice    = renderPrice;
})();
